import { fetchOnlinePay, getOnlinePay } from "utils/api";

export const queryMerchant = async (params) => {
  return await getOnlinePay("/merchant/list", {
    sort: "create_time,desc",
    ...params,
  });
};
export const updateStatus = async (params) => {
  return await fetchOnlinePay("/action", {
    action: "updateMerchants",
    ...params,
  });
};
